import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_IMPORT_LOADING = 'GET_ROUTE_IMPORT_LOADING';
export const GET_ROUTE_IMPORT_SUCCESS = 'GET_ROUTE_IMPORT_SUCCESS';
export const GET_ROUTE_IMPORT_REJECT = 'GET_ROUTE_IMPORT_REJECT';

//* ACTIONS ------------------------------------------------
export const getRoutesImportLoading = () => ({ type: GET_ROUTE_IMPORT_LOADING });
export const getRoutesImportSuccess = (payload) => ({ type: GET_ROUTE_IMPORT_SUCCESS, payload });
export const getRoutesImportReject = (payload) => ({ type: GET_ROUTE_IMPORT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getRoutesImportRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Notifications/web/GetAllRouteImportLastMile`, options);
};

